import React from 'react'
import Controlled from './Controlled'

function App() {
  return (
    <div className="wrapper">
      <Controlled />
    </div>
  )
}

export default App
